import type { Forwarded } from '../../api/types'
import { Icon } from '../../components/Icon'
import { userName } from '../../lib/channels'
import { formatDateTime, formatShortDate } from '../../lib/format'
import { useConversation } from './ConversationContext'

/** Above a forwarded message: who first wrote it and when (spec D1). Never where it came from. */
export function ForwardedLabel({ forwarded }: { forwarded: Forwarded }) {
  const { users } = useConversation()
  const author = forwarded.authorName || userName(users, forwarded.authorId)
  return (
    <p className="forwarded-label">
      <Icon name="forward" />
      <span>
        Forwarded <span aria-hidden="true">·</span> {author},{' '}
        <time dateTime={forwarded.createdAt} title={formatDateTime(forwarded.createdAt)}>
          {formatShortDate(forwarded.createdAt)}
        </time>
      </span>
    </p>
  )
}
